export default "__VITE_ASSET__CM5Mtda2__"